export default "__VITE_ASSET__BXmTGRbH__"